import { render, staticRenderFns } from "./fafang.vue?vue&type=template&id=7d5f2df2&scoped=true"
import script from "./fafang.vue?vue&type=script&lang=js"
export * from "./fafang.vue?vue&type=script&lang=js"
import style0 from "./fafang.vue?vue&type=style&index=0&id=7d5f2df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5f2df2",
  null
  
)

export default component.exports